import { useEffect } from 'react';
import LoadingPage from '../../../components/LoadingPage/LoadingPage';
import LangEnum from '../../../lang/LangEnum';
import { resetApp } from '../../../utils/resetApp.util';
import { useTranslation } from '../../translation/TranslationContext';

const ResetAppPage = () => {
  const { translate } = useTranslation();

  const resetAppAndGoHome = async () => {
    if (confirm(translate(LangEnum.CONFIRM_RESET_APP))) {
      await resetApp();

      window.location.pathname = '/';
    }
  };

  useEffect(() => {
    resetAppAndGoHome();
  }, []);

  return <LoadingPage />;
};

export default ResetAppPage;
